import React from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, Link } from '@mui/material';

interface IFcScrollNavigationControlsProps {
  onJumpToBottom: () => void;
  onJumpToTop: () => void;
  containerClassName?: string;
  controlClassName?: string;
  showJumpToBottom?: boolean;
  showJumpToTop?: boolean;
}

const FcScrollNavigationControls: React.FC<IFcScrollNavigationControlsProps> = ({
  onJumpToBottom,
  onJumpToTop,
  containerClassName,
  controlClassName,
  showJumpToBottom = true,
  showJumpToTop = true,
}) => {
  return (
    <Box className={containerClassName} data-qa-id="fc-scroll-navigation-controls">
      {showJumpToBottom ? (
        <Link
          component="button"
          type="button"
          onClick={onJumpToBottom}
          className={controlClassName}
          aria-label="Jump to bottom"
          data-qa-id="fc-jump-to-bottom"
        >
          <ArrowDownward fontSize="inherit" />
          Jump to Bottom
        </Link>
      ) : null}
      {showJumpToTop ? (
        <Link
          component="button"
          type="button"
          onClick={onJumpToTop}
          className={controlClassName}
          aria-label="Back to top"
          data-qa-id="fc-back-to-top"
        >
          <ArrowUpward fontSize="inherit" />
          Back to Top
        </Link>
      ) : null}
    </Box>
  );
};

export default FcScrollNavigationControls;
